/* Native details remain usable without JavaScript. */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const open = [...document.querySelectorAll('.wah-site-header details[open], .wah-filter[open]')];
  const focused = open.reverse().find((details) => details.contains(document.activeElement));
  if (focused) {
    focused.open = false;
    focused.querySelector('summary')?.focus();
  } else open.forEach((details) => { details.open = false; });
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.wah-site-header details[open], .wah-filter[open]').forEach((details) => {
    if (!details.contains(event.target)) details.open = false;
  });
});
